import { React, FC, useContext, useMemo } from 'external/react'
import { styled, clsx } from 'external/material'
import SearchPattern from 'components/search-pattern'
import LanguageFilter from 'components/language-filter'
import { TeacherContext } from 'teacher/context'

import SubjectCard from './SubjectCard'
import './catalogue-subjects.styl'

type CatalogueSubjectsProps = {
  className?: string    
}

const StyledCatalogueSubjects = styled('div')(catalogueSubjectStyles as any)

const CatalogueSubjects: FC<CatalogueSubjectsProps> = props => {
  const { className } = props
  const { catalogueSubjects = [], link, match, query } = useContext(TeacherContext) as any
  
  const subjects = useMemo(() => {
    return catalogueSubjects.map((s: any) => ({
        ...s,
        id: s.id,
        lessonCount: s.lessonCount || s.lessons?.length,
        to: link({ subject: s.id }, match.path, { preserveQuery: true })
    }))
  }, [catalogueSubjects, match.path])
  
  return (
    <StyledCatalogueSubjects className={clsx('catalogue-subjects', className)}>
      <div className="filters">
        <div className="filters-row">
          <LanguageFilter />
          <div className="filter filler" />
          <SearchPattern searchPlaceholder="" initialPattern={query.pattern} />
        </div>
      </div>
      
      <div className="content">
        <div className="subjects-grid">
          {subjects.map((s: any) => (
            <SubjectCard 
              key={s.id}
              {...s}
            />
          ))}
        </div>
      </div>
    </StyledCatalogueSubjects>
  )
}

export { CatalogueSubjects as default }

function catalogueSubjectStyles() {
  return {
      maxWidth: 1800,
      justifySelf: 'center',
     display: 'flex',
     flexgrow: 1,
     flexDirection: 'column',
     '& .filters-row': {
        display: 'flex',
        justifyContent: 'space-evenly',
        '& .filter': {
          width: 'calc(100% / 3 - 40px)',
          minWidth: 'calc(100% / 3 - 40px)',
          maxWidth: 'calc(100% / 3 - 40px)',
          padding: '20px 0 15px 0',
          color: '#838895',
        },
        '&.filler': {
            backgroundColor: 'transparent',
            border: 'none'
        }
    },
    '& .content': {
      flex: 1,
      maxWidth: 1800,
      overflow: 'auto',
      padding: 25
    },
    '& .subjects-grid': {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
      gap: 50,
    }
  }
}